import * as log from 'loglevel';

// Verbose in dev; only warn/error reach the console in production
log.setLevel(import.meta.env.PROD ? log.levels.WARN : log.levels.TRACE);

declare global {
  interface Window {
    log?: typeof log;
  }
}

window.log = log.noConflict();
